import Vue from 'vue'
import Vuex from 'vuex'
import * as firebase from 'firebase'
// import L from 'leaflet'

// import actions from './actions'
// import mutations from './mutations'
// import getters from './getters'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    loadedCutouts: [
      {
        imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/4/47/New_york_times_square-terabass.jpg',
        id: 'afajfjadfaadfa323',
        title: 'Meetup in New York',
        date: new Date(),
        location: 'New York',
        description: 'New York, New York!'
      }
    ],
    inverse: true,
    cluster: false,
    punchlist: [
      { category: 'houseKeeping', done: false, title: 'ensure the login process works by limiting access to those not logged in' },
      { category: 'houseKeeping', done: false, title: 'clean-up time and pixel picker pages' },
      { category: 'houseKeeping', done: false, title: 'move the basemap control to left-side' },
      { category: 'houseKeeping', done: false, title: 'see about a print-button' },
      { category: 'houseKeeping', done: false, title: 'find missing icons for controls??' },
      { category: 'houseKeeping', done: false, title: 'center the attribution beneath the time fabs' },
      { category: 'houseKeeping', done: false, title: 'add an "about" page' },
      { category: 'houseKeeping', done: false, title: 'add a "profile" page' },
      { category: 'paywall', done: false, title: 'add gallery of selected images with purchasing option' },
      { category: 'paywall', done: false, title: 'mimic above based on meetups registration' },
      { category: 'paywall', done: false, title: 'stripe or paypal hookup' },
      { category: 'map', done: false, title: 'add an inverse model' },
      { category: 'map', done: false, title: 'add the cluster-map, e.g., global option (might be a different app)' },
      { category: 'map', done: false, title: 'add geolocation' },
      { category: 'map', done: false, title: 'add colorpicker, i.e., add various color-schemes to times' },
      { category: 'app', done: false, title: 'finish the PWA elements' },
      { category: 'timepicker', done: false, title: 'add option for single times, probably have an open dialog on time picker that splits between single and three-time options' },
      { category: 'map', done: false, title: 'see about a mapbox version (maybe major)' },
      { category: 'travelpicker', done: false, title: 'add  (basically already written)' },
      { category: 'app', done: false, title: 'write the about and profile pages' }
    ],
    user: 'SNF',
    loading: false,
    error: null,
    verPois: [
      { name: 'Woodstock Town Crier', town: 'Woodstock', lat: 43.625158, lng: -72.518432 },
      { name: 'Woodstock Inn', town: 'Woodstock', lat: 43.623253, lng: -72.518900 },
      { name: 'Killington Ski Area', town: 'Killington', lat: 43.617563, lng: -72.802489 },
      { name: 'Killington Grand Resort', town: 'Killington', lat: 43.626820, lng: -72.794226 },
      { name: 'Stowe Mountain Resort', town: 'Stowe', lat: 44.529778, lng: -72.779285 },
      { name: 'Trapp Family Lodge', town: 'Stowe', lat: 44.468267, lng: -72.745886 },
      { name: 'The Equinox', town: 'Manchester', lat: 43.161947, lng: -73.072549 },
      { name: 'Dartmouth College', town: 'Hanover', lat: 43.704448, lng: -72.288661 },
      { name: 'Church Street', town: 'Burlington', lat: 44.478144, lng: -73.212614 },
      { name: 'Jackson Gore Inn', town: 'Ludlow', lat: 43.422628, lng: -72.71654 },
      { name: 'Stratton Mountain Resort', town: 'South Londonderry', lat: 43.113457, lng: -72.908119 },
      { name: 'Vermont State Capital', town: 'Montpelier', lat: 44.262576, lng: -72.580463 },
      { name: 'Hope Cemetery', town: 'Barre', lat: 44.210716, lng: -72.499444 },
      { name: 'Burrows Trailhead, Camels Hump State Park', town: 'Duxbury', lat: 44.304873, lng: -72.907891 },
      { name: 'Belmont General Store', town: 'Mount Holly', lat: 43.414961, lng: -72.821391 }
    ],
    verSch: [
      { name: 'Academy School', estsiz: '360', grades: 'K-6', lat: 42.851176, lng: -72.597994, schcat: 'Elementary School', schdis: 'Brattleboro', townam: 'Brattleboro', value: false },
      { name: 'Addison Central School', estsiz: '100', grades: 'K-6', lat: 44.0879679, lng: -73.304713, schcat: 'Elementary School', schdis: 'Addison', townam: 'Addison', value: false },
      { name: 'Albany Community School', estsiz: '80', grades: 'K-8', lat: 44.737995, lng: -72.376839, schcat: 'K-8', schdis: 'Albany', townam: 'Albany', value: false },
      { name: 'Albert Bridge School (West Windsor)', estsiz: '70', grades: 'K-6', lat: 43.4694223, lng: -72.4714816, schcat: 'Elementary School', schdis: 'West Windsor', townam: 'Brownsville', value: false },
      { name: 'Albert D Lawton School', estsiz: '340', grades: '6-8', lat: 44.4869722, lng: -73.0987693, schcat: 'Middle School', schdis: 'Essex Junction ID', townam: 'Essex Junction', value: false },
      { name: 'Alburgh Community Education Center', estsiz: '190', grades: 'K-8', lat: 44.979204, lng: -73.2982707, schcat: 'K-8', schdis: 'Alburgh', townam: 'Alburg', value: false },
      { name: 'Arlington Memorial', estsiz: '180', grades: '6-12', lat: 43.065997, lng: -73.1508814, schcat: 'Junior-Senior High School', schdis: 'Arlington', townam: 'Arlington', value: false },
      { name: 'Bakersfield School', estsiz: '180', grades: 'PK-8', lat: 44.7842811, lng: -72.8027989, schcat: 'K-8', schdis: 'Bakersfield', townam: 'Bakersfield', value: false },
      { name: 'Barnard Central School', estsiz: '80', grades: 'PK-6', lat: 43.7271345, lng: -72.6195002, schcat: 'Elementary School', schdis: 'Barnard', townam: 'Barnard', value: false },
      { name: 'Barnet Elementary School', estsiz: '190', grades: 'K-8', lat: 44.307334, lng: -72.080737, schcat: 'K-8', schdis: 'Barnet', townam: 'Barnet', value: false },
      { name: 'Barre City Elementary-Middle School', estsiz: '880', grades: 'PK-8', lat: 44.1845142, lng: -72.5047609, schcat: 'K-8', schdis: 'Barre City', townam: 'Barre', value: false },
      { name: 'Barre Town Elementary School', estsiz: '850', grades: 'PK-8', lat: 44.168403, lng: -72.486165, schcat: 'K-8', schdis: 'Barre Town', townam: 'Barre', value: false },
      { name: 'Barstow Memorial Joint Contract School', estsiz: '240', grades: 'PK-8', lat: 43.7010447, lng: -72.9524235, schcat: 'K-8', schdis: 'Barstow Memorial Joint Contract School', townam: 'Chittenden', value: false },
      { name: 'Barton Graded School', estsiz: '180', grades: 'K-8', lat: 44.749023, lng: -72.180092, schcat: 'K-8', schdis: 'Barton ID', townam: 'Barton', value: false },
      { name: 'Beeman Elementary School', estsiz: '110', grades: 'K-6', lat: 44.125328, lng: -73.153222, schcat: 'Elementary School', schdis: 'New Haven', townam: 'New Haven', value: false },
      { name: 'Bellows Falls Middle School', estsiz: '250', grades: '5-8', lat: 43.1333656, lng: -72.4462749, schcat: 'Middle School', schdis: 'Rockingham', townam: 'Bellows Falls', value: false },
      { name: 'Bellows Falls UHSD No 27', estsiz: '350', grades: '9-12', lat: 43.1364725, lng: -72.4442318, schcat: 'Senior High School', schdis: 'Bellows Falls UHSD', townam: 'Bellows Falls', value: false },
      { name: 'Bellows Free Academy (Fairfax)', estsiz: '590', grades: 'PK-8', lat: 44.6635996, lng: -73.0132732, schcat: 'K-8', schdis: 'Fairfax', townam: 'Fairfax', value: false },
      { name: 'Bellows Free Academy High School (Fairfax)', estsiz: '340', grades: '9-12', lat: 44.8080266, lng: -73.0828117, schcat: 'Senior High School', schdis: 'Fairfax', townam: 'St Albans', value: false },
      { name: 'Bellows Free Academy UHSD No 48', estsiz: '1', grades: '9-12', lat: 44.6635996, lng: -73.0132732, schcat: 'Senior High School', schdis: 'Bellows Free Academy UHSD', townam: 'Fairfax', value: false },
      { name: 'Bennington Elementary School', estsiz: '270', grades: 'K-5', lat: 42.88073, lng: -73.1935139, schcat: 'Elementary School', schdis: 'Bennington ID', townam: 'Bennington', value: false },
      { name: 'Benson Village School', estsiz: '140', grades: 'PK-8', lat: 43.7072408, lng: -73.302237, schcat: 'K-8', schdis: 'Benson', townam: 'Benson', value: false },
      { name: 'Berkshire Elementary School', estsiz: '200', grades: 'PK-8', lat: 44.9724974, lng: -72.7662099, schcat: 'K-8', schdis: 'Berkshire', townam: 'Richford', value: false },
      { name: 'Berlin Elementary School', estsiz: '220', grades: 'PK-6', lat: 44.2145063, lng: -72.5717356, schcat: 'Elementary School', schdis: 'Berlin', townam: 'Berlin', value: false },
      { name: 'Bethel Elementary School', estsiz: '140', grades: 'K-6', lat: 43.833232, lng: -72.6435001, schcat: 'Elementary School', schdis: 'Bethel', townam: 'Bethel', value: false },
      { name: 'Black River USD No 39', estsiz: '190', grades: '7-12', lat: 43.397114, lng: -72.688557, schcat: 'Junior-Senior High School', schdis: 'Black River UHSD', townam: 'Ludlow', value: false },
      { name: 'Blue Mountain USD No 21', estsiz: '440', grades: 'PK-12', lat: 44.1553744, lng: -72.0833144, schcat: 'K-12', schdis: 'Blue Mountain USD', townam: 'Wells River', value: false },
      { name: 'Bradford Elementary School', estsiz: '200', grades: 'K-6', lat: 44.0026079, lng: -72.1224734, schcat: 'Elementary School', schdis: 'Bradford ID', townam: 'Bradford', value: false },
      { name: 'Braintree School', estsiz: '80', grades: 'K-6', lat: 43.955559, lng: -72.72245, schcat: 'Elementary School', schdis: 'Braintree', townam: 'Braintree', value: false },
      { name: 'Bratt Area Middle School UHSD No 6', estsiz: '260', grades: '7-8', lat: 42.83564, lng: -72.561716, schcat: 'Middle School', schdis: 'Brattleboro UHSD', townam: 'Brattleboro', value: false },
      { name: 'Brattleboro UHSD No 6', estsiz: '880', grades: '9-12', lat: 42.836739, lng: -72.561267, schcat: 'Senior High School', schdis: 'Brattleboro UHSD', townam: 'Brattleboro', value: false },
      { name: 'Brewster Pierce School', estsiz: '150', grades: 'PK-4', lat: 44.2958862, lng: -72.9635912, schcat: 'Elementary School', schdis: 'Huntington', townam: 'Huntington', value: false },
      { name: 'Bridport Central School', estsiz: '90', grades: 'PK-6', lat: 43.9809453, lng: -73.3158066, schcat: 'Elementary School', schdis: 'Bridport', townam: 'Bridport', value: false },
      { name: 'Brighton Elementary School', estsiz: '100', grades: 'PK-8', lat: 44.8215785, lng: -71.8938945, schcat: 'K-8', schdis: 'Brighton', townam: 'Island Pond', value: false },
      { name: 'Bristol Elementary School', estsiz: '280', grades: 'K-6', lat: 44.1379395, lng: -73.0770421, schcat: 'Elementary School', schdis: 'Bristol', townam: 'Bristol', value: false },
      { name: 'Brookfield School', estsiz: '80', grades: 'K-6', lat: 44.016395, lng: -72.606683, schcat: 'Elementary School', schdis: 'Brookfield', townam: 'Brookfield', value: false },
      { name: 'Brownington Central School', estsiz: '100', grades: 'K-8', lat: 44.819904, lng: -72.137688, schcat: 'K-8', schdis: 'Brownington', townam: 'Brownington', value: false },
      { name: 'Browns River Middle USD No 17', estsiz: '410', grades: '5-8', lat: 44.5192478, lng: -72.9441695, schcat: 'Middle School', schdis: 'Mt. Mansfield USD', townam: 'Jericho', value: false },
      { name: 'Burke Town School', estsiz: '190', grades: 'K-8', lat: 44.625084, lng: -71.960265, schcat: 'K-8', schdis: 'Burke', townam: 'West Burke', value: false },
      { name: 'Burlington Senior High School', estsiz: '1', grades: '9-12', lat: 44.4963229, lng: -73.235261, schcat: 'Senior High School', schdis: 'Burlington', townam: 'Burlington', value: false },
      { name: 'C P Smith School', estsiz: '260', grades: 'K-5', lat: 44.513102, lng: -73.243035, schcat: 'Elementary School', schdis: 'Burlington', townam: 'Burlington', value: false },
      { name: 'Cabot School', estsiz: '230', grades: 'PK-12', lat: 44.4034302, lng: -72.3093358, schcat: 'K-12', schdis: 'Cabot', townam: 'Cabot', value: false },
      { name: 'Calais Elementary School', estsiz: '140', grades: 'PK-6', lat: 44.3193948, lng: -72.4516452, schcat: 'Elementary School', schdis: 'Calais', townam: 'Plainfield', value: false },
      { name: 'Cambridge Elementary School', estsiz: '370', grades: 'PK-6', lat: 44.6444743, lng: -72.8267715, schcat: 'Elementary School', schdis: 'Cambridge', townam: 'Jeffersonville', value: false },
      { name: 'Camels Hump Middle USD No 17', estsiz: '380', grades: '5-8', lat: 44.4135271, lng: -72.9943127, schcat: 'Middle School', schdis: 'Mt. Mansfield USD', townam: 'Richmond', value: false },
      { name: 'Canaan Schools', estsiz: '190', grades: 'K-12', lat: 44.99537, lng: -71.537662, schcat: 'K-12', schdis: 'Canaan', townam: 'Canaan', value: false },
      { name: 'Castleton Hubbardton USD No 42', estsiz: '390', grades: 'PK-8', lat: 43.612408, lng: -73.178207, schcat: 'K-8', schdis: 'Castleton-Hubbardton UESD', townam: 'Castleton', value: false },
      { name: 'Cavendish Town Elementary School', estsiz: '120', grades: 'PK-6', lat: 43.3836765, lng: -72.6368872, schcat: 'Elementary School', schdis: 'Cavendish', townam: 'Proctorsville', value: false },
      { name: 'Chamberlin School', estsiz: '260', grades: 'K-5', lat: 44.4713727, lng: -73.1654672, schcat: 'Elementary School', schdis: 'South Burlington', townam: 'So Burlington', value: false },
      { name: 'Champlain School', estsiz: '340', grades: 'K-5', lat: 44.457065, lng: -73.213221, schcat: 'Elementary School', schdis: 'Burlington', townam: 'Burlington', value: false },
      { name: 'Champlain Valley UHSD No 15', estsiz: '1', grades: '9-12', lat: 44.3446552, lng: -73.1099525, schcat: 'Senior High School', schdis: 'Champlain Valley UHSD', townam: 'Hinesburg', value: false },
      { name: 'Charleston Elementary School', estsiz: '120', grades: 'PK-8', lat: 44.843109, lng: -72.019768, schcat: 'K-8', schdis: 'Charleston', townam: 'West Charleston', value: false },
      { name: 'Charlotte Central School', estsiz: '460', grades: 'PK-8', lat: 44.315086, lng: -73.226451, schcat: 'K-8', schdis: 'Charlotte', townam: 'Charlotte', value: false },
      { name: 'Chelsea High School', estsiz: '160', grades: 'K-12', lat: 43.987282, lng: -72.446617, schcat: 'K-12', schdis: 'Chelsea', townam: 'Chelsea', value: false },
      { name: 'Chester-Andover Elementary School', estsiz: '300', grades: 'PK-6', lat: 43.2646923, lng: -72.5954546, schcat: 'Elementary School', schdis: 'Chester-Andover UESD', townam: 'Chester', value: false },
      { name: 'Clarendon Elementary School', estsiz: '210', grades: 'PK-6', lat: 43.5634, lng: -72.96786, schcat: 'Elementary School', schdis: 'Clarendon', townam: 'North Clarendon', value: false },
      { name: 'Colchester High School', estsiz: '730', grades: '9-12', lat: 44.5399122, lng: -73.2138341, schcat: 'Senior High School', schdis: 'Colchester', townam: 'Colchester', value: false },
      { name: 'Colchester Middle School', estsiz: '520', grades: '6-8', lat: 44.5405118, lng: -73.2097506, schcat: 'Middle School', schdis: 'Colchester', townam: 'Colchester', value: false },
      { name: 'Concord School', estsiz: '190', grades: 'PK-12', lat: 44.4266783, lng: -71.8904608, schcat: 'K-12', schdis: 'Concord', townam: 'Concord', value: false },
      { name: 'Cornwall Elementary School', estsiz: '90', grades: 'K-6', lat: 43.963902, lng: -73.2063979, schcat: 'Elementary School', schdis: 'Cornwall', townam: 'Cornwall', value: false },
      { name: 'Coventry Village School', estsiz: '100', grades: 'K-8', lat: 44.8628287, lng: -72.2650021, schcat: 'K-8', schdis: 'Coventry', townam: 'Coventry', value: false },
      { name: 'Craftsbury Schools', estsiz: '160', grades: 'K-12', lat: 44.6541939, lng: -72.381984, schcat: 'K-12', schdis: 'Craftsbury', townam: 'Craftsbury Comm', value: false },
      { name: 'Crossett Brook Middle USD No 45', estsiz: '290', grades: '5-8', lat: 44.321123, lng: -72.7528363, schcat: 'Middle School', schdis: 'Duxbury-Waterbury UESD', townam: 'Duxbury', value: false },
      { name: 'Currier Memorial USD No 23', estsiz: '100', grades: 'K-6', lat: 43.3497894, lng: -72.9951757, schcat: 'Elementary School', schdis: 'Currier Memorial UESD', townam: 'Danby', value: false },
      { name: 'Danville School', estsiz: '340', grades: 'K-12', lat: 44.4108915, lng: -72.1437508, schcat: 'K-12', schdis: 'Danville', townam: 'Danville', value: false },
      { name: 'Derby Elementary School', estsiz: '330', grades: 'K-6', lat: 45.001503, lng: -72.118345, schcat: 'Elementary School', schdis: 'Derby', townam: 'Derby Line', value: false },
      { name: 'Dorset School, The', estsiz: '170', grades: 'K-8', lat: 43.2219794, lng: -73.0657074, schcat: 'K-8', schdis: 'Dorset', townam: 'Dorset', value: false },
      { name: 'Dothan Brook School', estsiz: '250', grades: 'K-5', lat: 43.687628, lng: -72.3217171, schcat: 'Elementary School', schdis: 'Hartford', townam: 'White River Jct', value: false },
      { name: 'Doty Memorial School', estsiz: '90', grades: 'PK-6', lat: 44.373349, lng: -72.547949, schcat: 'Elementary School', schdis: 'Worcester', townam: 'Worcester', value: false },
      { name: 'Dover Elementary School', estsiz: '100', grades: 'PK-6', lat: 42.938863, lng: -72.80991, schcat: 'Elementary School', schdis: 'Dover', townam: 'East Dover', value: false },
      { name: 'Dummerston Schools', estsiz: '180', grades: 'K-8', lat: 42.9336033, lng: -72.5379992, schcat: 'K-8', schdis: 'Dummerston', townam: 'East Dummerston', value: false },
      { name: 'East Montpelier Elementary School', estsiz: '260', grades: 'PK-6', lat: 44.2866171, lng: -72.4953304, schcat: 'Elementary School', schdis: 'East Montpelier', townam: 'East Montpelier', value: false },
      { name: 'Eden Central School', estsiz: '140', grades: 'PK-6', lat: 44.704038, lng: -72.563901, schcat: 'Elementary School', schdis: 'Eden', townam: 'Eden', value: false },
      { name: 'Edmunds Elementary School', estsiz: '360', grades: 'K-5', lat: 44.475518, lng: -73.20729, schcat: 'Elementary School', schdis: 'Burlington', townam: 'Burlington', value: false },
      { name: 'Edmunds Middle School', estsiz: '390', grades: '6-8', lat: 44.475468, lng: -73.208086, schcat: 'Middle School', schdis: 'Burlington', townam: 'Burlington', value: false },
      { name: 'Elm Hill School', estsiz: '290', grades: 'K-2', lat: 43.3061209, lng: -72.4844404, schcat: 'Elementary School', schdis: 'Springfield', townam: 'Springfield', value: false },
      { name: 'Enosburg Falls Elementary School', estsiz: '250', grades: 'PK-5', lat: 44.904316, lng: -72.801033, schcat: 'Elementary School', schdis: 'Enosburgh', townam: 'Enosburg Falls', value: false },
      { name: 'Enosburg Falls Junior-Senior High School', estsiz: '440', grades: '6-12', lat: 44.9053176, lng: -72.8039149, schcat: 'Junior-Senior High School', schdis: 'Enosburgh', townam: 'Enosburg Falls', value: false },
      { name: 'Essex Community Education Center UHSD No 46', estsiz: '1', grades: '9-12', lat: 44.4982009, lng: -73.1100265, schcat: 'Senior High School', schdis: 'Essex Comm. Ed. Ctr. UHSD', townam: 'Essex Junction', value: false },
      { name: 'Essex Elementary School', estsiz: '440', grades: 'PK-2', lat: 44.5130041, lng: -73.0555147, schcat: 'Elementary School', schdis: 'Essex Town', townam: 'Essex Junction', value: false },
      { name: 'Essex Middle School', estsiz: '420', grades: '6-8', lat: 44.4992447, lng: -73.0579969, schcat: 'Middle School', schdis: 'Essex Town', townam: 'Essex Junction', value: false },
      { name: 'Fair Haven Grade School', estsiz: '360', grades: 'PK-8', lat: 43.5948092, lng: -73.2644651, schcat: 'K-8', schdis: 'Fair Haven', townam: 'Fair Haven', value: false },
      { name: 'Fair Haven UHSD No 16', estsiz: '430', grades: '9-12', lat: 43.6035814, lng: -73.2703625, schcat: 'Senior High School', schdis: 'Fair Haven UHSD', townam: 'Fair Haven', value: false },
      { name: 'Fairfield Center School', estsiz: '220', grades: 'K-8', lat: 44.80051, lng: -72.947922, schcat: 'K-8', schdis: 'Fairfield', townam: 'Fairfield', value: false },
      { name: 'Fayston Elementary School', estsiz: '110', grades: 'PK-6', lat: 44.1791977, lng: -72.8842112, schcat: 'Elementary School', schdis: 'Fayston', townam: 'Fayston', value: false },
      { name: 'Ferrisburgh Central School', estsiz: '210', grades: 'K-6', lat: 44.206608, lng: -73.247734, schcat: 'Elementary School', schdis: 'Ferrisburgh', townam: 'Ferrisburgh', value: false },
      { name: 'Fisher School', estsiz: '160', grades: 'PK-5', lat: 43.066169, lng: -73.153659, schcat: 'Elementary School', schdis: 'Arlington', townam: 'Arlington', value: false },
      { name: 'Fletcher Elementary School', estsiz: '130', grades: 'PK-6', lat: 44.67049, lng: -72.923782, schcat: 'Elementary School', schdis: 'Fletcher', townam: 'Cambridge', value: false },
      { name: 'Flood Brook USD No 20 (School)', estsiz: '300', grades: 'PK-8', lat: 43.2367859, lng: -72.8480324, schcat: 'K-8', schdis: 'Flood Brook UESD', townam: 'Londonderry', value: false },
      { name: 'Folsom Education and Community Center', estsiz: '120', grades: 'K-8', lat: 44.636311, lng: -73.3022079, schcat: 'K-8', schdis: 'South Hero', townam: 'South Hero', value: false },
      { name: 'Founders Memorial School', estsiz: '420', grades: '3-5', lat: 44.5004481, lng: -73.0553216, schcat: 'Elementary School', schdis: 'Essex Town', townam: 'Essex Junction', value: false },
      { name: 'Franklin Central School', estsiz: '130', grades: 'K-6', lat: 44.9842389, lng: -72.9201647, schcat: 'Elementary School', schdis: 'Franklin', townam: 'Franklin', value: false },
      { name: 'Frederick H Tuttle Middle School', estsiz: '550', grades: '6-8', lat: 44.4567486, lng: -73.1774257, schcat: 'Middle School', schdis: 'South Burlington', townam: 'S Burlington', value: false },
      { name: 'Georgia Elementary-Middle School', estsiz: '630', grades: 'PK-8', lat: 44.7350207, lng: -73.1144163, schcat: 'K-8', schdis: 'Georgia', townam: 'St Albans', value: false },
      { name: 'Glover Community School', estsiz: '130', grades: 'K-8', lat: 44.705938, lng: -72.189466, schcat: 'K-8', schdis: 'Glover', townam: 'Glover', value: false },
      { name: 'Grand Isle Elementary School', estsiz: '210', grades: 'K-8', lat: 44.725599, lng: -73.2915204, schcat: 'K-8', schdis: 'Grand Isle', townam: 'Grand Isle', value: false },
      { name: 'Green Mountain UHSD No 35', estsiz: '360', grades: '7-12', lat: 43.253613, lng: -72.581459, schcat: 'Junior-Senior High School', schdis: 'Green Mountain UHSD', townam: 'Chester', value: false },
      { name: 'Green Street School', estsiz: '250', grades: 'K-6', lat: 42.85174, lng: -72.565, schcat: 'Elementary School', schdis: 'Brattleboro', townam: 'Brattleboro', value: false },
      { name: 'Guilford Central School', estsiz: '140', grades: 'K-8', lat: 42.800709, lng: -72.6223515, schcat: 'K-8', schdis: 'Guilford', townam: 'Guilford', value: false },
      { name: 'Halifax School', estsiz: '60', grades: 'K-8', lat: 42.784431, lng: -72.768503, schcat: 'K-8', schdis: 'Halifax', townam: 'West Halifax', value: false },
      { name: 'Hardwick Elementary School', estsiz: '270', grades: 'K-6', lat: 44.5033274, lng: -72.3681449, schcat: 'Elementary School', schdis: 'Hardwick', townam: 'Hardwick', value: false },
      { name: 'Hartford High School', estsiz: '610', grades: '9-12', lat: 43.657753, lng: -72.3188551, schcat: 'Senior High School', schdis: 'Hartford', townam: 'White River Jct', value: false },
      { name: 'Hartford Memorial Middle School', estsiz: '360', grades: '6-8', lat: 43.6563504, lng: -72.3201992, schcat: 'Middle School', schdis: 'Hartford', townam: 'White River Jct', value: false },
      { name: 'Hartland Elementary School', estsiz: '310', grades: 'K-8', lat: 43.5379884, lng: -72.3942648, schcat: 'K-8', schdis: 'Hartland', townam: 'Hartland', value: false },
      { name: 'Harwood UHSD No 19', estsiz: '580', grades: '9-12', lat: 44.2539876, lng: -72.7867166, schcat: 'Senior High School', schdis: 'Harwood UHSD', townam: 'Duxbury', value: false },
      { name: 'Harwood Union Middle UHSD No 19', estsiz: '160', grades: '7-8', lat: 44.2540115, lng: -72.7864532, schcat: 'Middle School', schdis: 'Harwood UHSD', townam: 'Duxbury', value: false },
      { name: 'Hazen UHSD No 26 (School)', estsiz: '370', grades: '7-12', lat: 44.508948, lng: -72.364683, schcat: 'Junior-Senior High School', schdis: 'Hazen UHSD', townam: 'Hardwick', value: false },
      { name: 'Hiawatha School', estsiz: '240', grades: 'PK-3', lat: 44.4885517, lng: -73.1269076, schcat: 'Elementary School', schdis: 'Essex Junction ID', townam: 'Essex Junction', value: false },
      { name: 'Highgate Schools', estsiz: '310', grades: 'K-6', lat: 44.94117, lng: -73.044022, schcat: 'Elementary School', schdis: 'Highgate', townam: 'Highgate Center', value: false },
      { name: 'Hinesburg Community School', estsiz: '480', grades: 'PK-8', lat: 44.32621, lng: -73.10778, schcat: 'K-8', schdis: 'Hinesburg', townam: 'Hinesburg', value: false },
      { name: 'Holland Elementary School', estsiz: '80', grades: 'PK-6', lat: 44.9730783, lng: -72.0133074, schcat: 'Elementary School', schdis: 'Holland', townam: 'Derby Line', value: false },
      { name: 'Hyde Park Elementary School', estsiz: '250', grades: 'PK-6', lat: 44.591888, lng: -72.6137179, schcat: 'Elementary School', schdis: 'Hyde Park', townam: 'Hyde Park', value: false },
      { name: 'Integrated Arts Academy At HO Wheeler', estsiz: '300', grades: 'PK-5', lat: 44.487972, lng: -73.213857, schcat: 'Elementary School', schdis: 'Burlington', townam: 'Burlington', value: false },
      { name: 'Irasburg Village School', estsiz: '130', grades: 'K-8', lat: 44.8036308, lng: -72.2728506, schcat: 'K-8', schdis: 'Irasburg', townam: 'Irasburg', value: false },
      { name: 'Isle La Motte Elementary School', estsiz: '40', grades: 'K-6', lat: 44.8823346, lng: -73.346067, schcat: 'Elementary School', schdis: 'Isle La Motte', townam: 'Isle Lamotte', value: false },
      { name: 'J F Kennedy Elementary School', estsiz: '440', grades: 'PK-5', lat: 44.500416, lng: -73.180687, schcat: 'Elementary School', schdis: 'Winooski ID', townam: 'Winooski', value: false },
      { name: 'J J Flynn School', estsiz: '360', grades: 'PK-5', lat: 44.517023, lng: -73.260002, schcat: 'Elementary School', schdis: 'Burlington', townam: 'Burlington', value: false },
      { name: 'Jamaica Village School', estsiz: '70', grades: 'PK-6', lat: 43.103771, lng: -72.775345, schcat: 'Elementary School', schdis: 'Jamaica', townam: 'Jamaica', value: false },
      { name: 'Jay-Westfield Joint Contract School', estsiz: '90', grades: 'K-6', lat: 44.952663, lng: -72.435028, schcat: 'Elementary School', schdis: 'Jay-Westfield Joint Contract School', townam: 'Jay', value: false },
      { name: 'Jericho Elementary School', estsiz: '220', grades: 'K-4', lat: 44.5053714, lng: -72.9897701, schcat: 'Elementary School', schdis: 'Jericho', townam: 'Jericho', value: false },
      { name: 'Johnson Elementary School', estsiz: '240', grades: 'PK-6', lat: 44.637031, lng: -72.674763, schcat: 'Elementary School', schdis: 'Johnson', townam: 'Johnson', value: false },
      { name: 'Lake Region UHSD No 24', estsiz: '370', grades: '9-12', lat: 44.782603, lng: -72.2206491, schcat: 'Senior High School', schdis: 'Lake Region UHSD', townam: 'Orleans', value: false },
      { name: 'Lakeview USD No 43', estsiz: '80', grades: 'K-6', lat: 44.580754, lng: -72.293904, schcat: 'Elementary School', schdis: 'Lakeview UESD', townam: 'Greensboro', value: false },
      { name: 'Lamoille UHSD No 18', estsiz: '570', grades: '9-12', lat: 44.6014224, lng: -72.6308753, schcat: 'Senior High School', schdis: 'Lamoille UHSD', townam: 'Hyde Park', value: false },
      { name: 'Lamoille Union Middle School No 18', estsiz: '280', grades: '7-8', lat: 44.601121, lng: -72.62991, schcat: 'Middle School', schdis: 'Lamoille UHSD', townam: 'Hyde Park', value: false },
      { name: 'Leicester Central School', estsiz: '60', grades: 'PK-6', lat: 43.8667079, lng: -73.1088582, schcat: 'Elementary School', schdis: 'Leicester', townam: 'Leicester', value: false },
      { name: 'Leland and Gray UHSD No 34', estsiz: '380', grades: '7-12', lat: 43.0465917, lng: -72.6670936, schcat: 'Junior-Senior High School', schdis: 'Leland & Gray UHSD', townam: 'Townshend', value: false },
      { name: 'Lincoln Community School', estsiz: '120', grades: 'K-6', lat: 44.09766, lng: -72.986305, schcat: 'Elementary School', schdis: 'Lincoln', townam: 'Lincoln', value: false },
      { name: 'Lothrop School', estsiz: '270', grades: 'PK-6', lat: 43.7055257, lng: -73.0190098, schcat: 'Elementary School', schdis: 'Pittsford', townam: 'Pittsford', value: false },
      { name: 'Lowell Graded School', estsiz: '120', grades: 'PK-8', lat: 44.8053359, lng: -72.448708, schcat: 'K-8', schdis: 'Lowell', townam: 'Lowell', value: false },
      { name: 'Ludlow Elementary School', estsiz: '130', grades: 'PK-6', lat: 44.8053359, lng: -72.448708, schcat: 'Elementary School', schdis: 'Ludlow', townam: 'Ludlow', value: false },
      { name: 'Lunenburg Schools', estsiz: '120', grades: 'PK-8', lat: 44.4147729, lng: -71.714483, schcat: 'K-8', schdis: 'Lunenburg', townam: 'Gilman', value: false },
      { name: 'Lyman C Hunt Middle School', estsiz: '390', grades: '6-8', lat: 44.513362, lng: -73.249199, schcat: 'Middle School', schdis: 'Burlington', townam: 'Burlington', value: false },
      { name: 'Lyndon Town School', estsiz: '460', grades: 'K-8', lat: 44.5465485, lng: -71.9853549, schcat: 'K-8', schdis: 'Lyndon', townam: 'Lyndonville', value: false },
      { name: 'Main Street School', estsiz: '180', grades: '6-8', lat: 44.2629656, lng: -72.5695793, schcat: 'Middle School', schdis: 'Montpelier', townam: 'Montpelier', value: false },
      { name: 'Malletts Bay School', estsiz: '480', grades: 'PK-5', lat: 44.5387028, lng: -73.2076928, schcat: 'Elementary School', schdis: 'Colchester', townam: 'Colchester', value: false },
      { name: 'Manchester Elementary-Middle School', estsiz: '450', grades: 'PK-8', lat: 43.178738, lng: -73.053734, schcat: 'K-8', schdis: 'Manchester', townam: 'Manchester Ctr', value: false },
      { name: 'Marion W Cross School', estsiz: '310', grades: 'K-6', lat: 43.7132317, lng: -72.3063544, schcat: 'Elementary School', schdis: 'Norwich', townam: 'Norwich', value: false },
      { name: 'Marlboro Elementary School', estsiz: '100', grades: 'PK-8', lat: 42.868698, lng: -72.719688, schcat: 'K-8', schdis: 'Marlboro', townam: 'Marlboro', value: false },
      { name: 'Mettawee Community School USD No 47', estsiz: '200', grades: 'PK-6', lat: 43.3857682, lng: -73.2243815, schcat: 'Elementary School', schdis: 'Mettawee Community Sch UESD', townam: 'West Pawlet', value: false },
      { name: 'Middlebury ID No 4 School', estsiz: '400', grades: 'K-6', lat: 44.0105946, lng: -73.1616527, schcat: 'Elementary School', schdis: 'Middlebury ID', townam: 'Middlebury', value: false },
      { name: 'Middlebury Senior UHSD No 3', estsiz: '660', grades: '9-12', lat: 44.0065835, lng: -73.1630676, schcat: 'Senior High School', schdis: 'Middlebury UHSD', townam: 'Middlebury', value: false },
      { name: 'Middlebury Union Middle School No 3', estsiz: '290', grades: '7-8', lat: 43.9982614, lng: -73.1524356, schcat: 'Middle School', schdis: 'Middlebury UHSD', townam: 'Middlebury', value: false },
      { name: 'Middletown Springs Elementary School', estsiz: '80', grades: 'PK-6', lat: 43.4839636, lng: -73.1203383, schcat: 'Elementary School', schdis: 'Middletown Springs', townam: 'Middletown Spr', value: false },
      { name: 'Mill River USD No 40', estsiz: '570', grades: '7-12', lat: 43.547028, lng: -72.97152, schcat: 'Junior-Senior High School', schdis: 'Mill River UHSD', townam: 'North Clarendon', value: false },
      { name: 'Millers Run School USD No 37', estsiz: '150', grades: 'PK-8', lat: 44.6026961, lng: -72.1192335, schcat: 'K-8', schdis: 'Millers Run UESD', townam: 'Sheffield', value: false },
      { name: 'Milton Elementary School', estsiz: '920', grades: 'PK-6', lat: 44.6324836, lng: -73.1098197, schcat: 'Elementary School', schdis: 'Milton', townam: 'Milton', value: false },
      { name: 'Milton Middle School', estsiz: '260', grades: '7-8', lat: 44.6280816, lng: -73.1197457, schcat: 'Middle School', schdis: 'Milton', townam: 'Milton', value: false },
      { name: 'Milton Senior High School', estsiz: '540', grades: '9-12', lat: 44.6280816, lng: -73.1197457, schcat: 'Senior High School', schdis: 'Milton', townam: 'Milton', value: false },
      { name: 'Missisquoi Valley UHSD No 7', estsiz: '940', grades: '7-12', lat: 44.927863, lng: -73.1018239, schcat: 'Junior-Senior High School', schdis: 'Missisquoi Valley UHSD', townam: 'Swanton', value: false },
      { name: 'Molly Stark School', estsiz: '390', grades: 'K-5', lat: 42.8992571, lng: -73.2017039, schcat: 'Elementary School', schdis: 'Bennington ID', townam: 'Bennington', value: false },
      { name: 'Monkton Central School', estsiz: '170', grades: 'K-6', lat: 44.2441871, lng: -73.1389253, schcat: 'Elementary School', schdis: 'Monkton', townam: 'No Ferrisburg', value: false },
      { name: 'Montgomery Center School', estsiz: '130', grades: 'PK-8', lat: 44.8864293, lng: -72.6162041, schcat: 'K-8', schdis: 'Montgomery', townam: 'Montgomery Ctr', value: false },
      { name: 'Montpelier High School', estsiz: '310', grades: '9-12', lat: 44.2605339, lng: -72.5869944, schcat: 'Senior High School', schdis: 'Montpelier', townam: 'Montpelier', value: false },
      { name: 'Monument School', estsiz: '150', grades: 'K-5', lat: 42.8850209, lng: -73.2106215, schcat: 'Elementary School', schdis: 'Bennington ID', townam: 'Bennington', value: false },
      { name: 'Moretown Elementary School', estsiz: '120', grades: 'PK-6', lat: 44.247814, lng: -72.7630619, schcat: 'Elementary School', schdis: 'Moretown', townam: 'Moretown', value: false },
      { name: 'Morristown Elementary Schools', estsiz: '300', grades: 'K-4', lat: 44.5636467, lng: -72.5855112, schcat: 'Elementary School', schdis: 'Morristown', townam: 'Morrisville', value: false },
      { name: 'Mt Abraham UHSD No 28', estsiz: '780', grades: '7-12', lat: 44.1354759, lng: -73.0939654, schcat: 'Junior-Senior High School', schdis: 'Mt. Abraham UHSD', townam: 'Bristol', value: false },
      { name: 'Mt Anthony Senior UHSD No 14', estsiz: '1000', grades: '9-12', lat: 42.8863217, lng: -73.1913331, schcat: 'Senior High School', schdis: 'Mt. Anthony UHSD', townam: 'Bennington', value: false },
      { name: 'Mt Anthony Union Middle School', estsiz: '610', grades: '6-8', lat: 42.9054159, lng: -73.1877428, schcat: 'Middle School', schdis: 'Mt. Anthony UHSD', townam: 'Bennington', value: false },
      { name: 'Mt Holly School', estsiz: '110', grades: 'PK-6', lat: 43.44585, lng: -72.823055, schcat: 'Elementary School', schdis: 'Mt. Holly', townam: 'Mount Holly', value: false },
      { name: 'Mt Mansfield USD No 17', estsiz: '950', grades: '9-12', lat: 44.486184, lng: -72.962048, schcat: 'Senior High School', schdis: 'Mt. Mansfield USD', townam: 'Jericho', value: false },
      { name: 'Neshobe School', estsiz: '410', grades: 'PK-6', lat: 43.8264649, lng: -73.0552279, schcat: 'Elementary School', schdis: 'Brandon', townam: 'Brandon', value: false },
      { name: 'Newark School', estsiz: '50', grades: 'K-8', lat: 44.690121, lng: -71.950768, schcat: 'K-8', schdis: 'Newark', townam: 'Newark', value: false },
      { name: 'Newbrook Joint Contract Elementary School', estsiz: '150', grades: 'PK-6', lat: 42.9599339, lng: -72.650055, schcat: 'Elementary School', schdis: 'Newbrook Joint Contract Elementary School', townam: 'Newfane', value: false },
      { name: 'Newbury Elementary School', estsiz: '120', grades: 'K-6', lat: 44.0794494, lng: -72.0603798, schcat: 'Elementary School', schdis: 'Newbury', townam: 'Newbury', value: false },
      { name: 'Newport City Elementary Schools', estsiz: '310', grades: 'K-6', lat: 44.9449812, lng: -72.1921709, schcat: 'Elementary School', schdis: 'Newport City', townam: 'Newport', value: false },
      { name: 'Newport Town School', estsiz: '100', grades: 'K-6', lat: 44.9509976, lng: -72.3068892, schcat: 'Elementary School', schdis: 'Newport Town', townam: 'Newport Center', value: false },
      { name: 'Newton Elementary School', estsiz: '140', grades: 'PK-8', lat: 43.8350684, lng: -72.3653719, schcat: 'K-8', schdis: 'Strafford', townam: 'South Strafford', value: false },
      { name: 'North Country Junior UHSD No 22', estsiz: '900', grades: '9-12', lat: 44.9493054, lng: -72.1313134, schcat: 'Senior High School', schdis: 'North Country Jr UHSD', townam: 'Derby', value: false },
      { name: 'North Country Senior UHSD No 22', estsiz: '290', grades: '7-8', lat: 44.946129, lng: -72.2035371, schcat: 'Middle School', schdis: 'North Country Sr UHSD', townam: 'Newport', value: false },
      { name: 'North Hero Elementary School', estsiz: '60', grades: 'PK-6', lat: 44.8508342, lng: -73.2634981, schcat: 'Elementary School', schdis: 'North Hero', townam: 'North Hero', value: false },
      { name: 'Northfield Elementary School', estsiz: '330', grades: 'PK-5', lat: 44.15455, lng: -72.662072, schcat: 'Elementary School', schdis: 'Northfield', townam: 'Northfield', value: false },
      { name: 'Northfield Middle-High School', estsiz: '350', grades: '6-12', lat: 44.153568, lng: -72.660537, schcat: 'Junior-Senior High School', schdis: 'Northfield', townam: 'Northfield', value: false },
      { name: 'Oak Grove School', estsiz: '140', grades: 'K-6', lat: 42.8401525, lng: -72.5579901, schcat: 'Elementary School', schdis: 'Brattleboro', townam: 'Brattleboro', value: false },
      { name: 'Orange Center School', estsiz: '100', grades: 'K-8', lat: 44.1490229, lng: -72.4035558, schcat: 'K-8', schdis: 'Orange', townam: 'East Barre', value: false },
      { name: 'Orchard School', estsiz: '380', grades: 'K-5', lat: 44.439761, lng: -73.207682, schcat: 'Elementary School', schdis: 'South Burlington', townam: 'So Burlington', value: false },
      { name: 'Orleans Elementary School', estsiz: '120', grades: 'K-8', lat: 44.810055, lng: -72.196754, schcat: 'K-8', schdis: 'Orleans ID', townam: 'Orleans', value: false },
      { name: 'Orwell Village School', estsiz: '130', grades: 'K-8', lat: 43.804552, lng: -73.299154, schcat: 'K-8', schdis: 'Orwell', townam: 'Orwell', value: false },
      { name: 'Ottauquechee School', estsiz: '210', grades: 'PK-5', lat: 43.6494962, lng: -72.4168673, schcat: 'Elementary School', schdis: 'Hartford', townam: 'Quechee', value: false },
      { name: 'Otter Valley UHSD No 8', estsiz: '580', grades: '7-12', lat: 43.7671716, lng: -73.0515465, schcat: 'Junior-Senior High School', schdis: 'Otter Valley UHSD', townam: 'Brandon', value: false },
      { name: 'Oxbow UHSD No 30', estsiz: '430', grades: '7-12', lat: 44.0078701, lng: -72.1139269, schcat: 'Junior-Senior High School', schdis: 'Oxbow UHSD', townam: 'Bradford', value: false },
      { name: 'Peacham Elementary School', estsiz: '40', grades: 'K-6', lat: 44.326018, lng: -72.16652, schcat: 'Elementary School', schdis: 'Peacham', townam: 'Peacham', value: false },
      { name: 'Peoples Academy', estsiz: '300', grades: '9-12', lat: 44.5626651, lng: -72.590118, schcat: 'Senior High School', schdis: 'Morristown', townam: 'Morrisville', value: false },
      { name: 'Peoples Academy Middle School', estsiz: '280', grades: '5-8', lat: 44.5626651, lng: -72.590118, schcat: 'Middle School', schdis: 'Morristown', townam: 'Morrisville', value: false },
      { name: 'Porters Point School', estsiz: '250', grades: 'K-2', lat: 44.5412597, lng: -73.2553252, schcat: 'Elementary School', schdis: 'Colchester', townam: 'Colchester', value: false },
      { name: 'Poultney Elementary School', estsiz: '210', grades: 'PK-6', lat: 43.524576, lng: -73.237674, schcat: 'Elementary School', schdis: 'Poultney', townam: 'Poultney', value: false },
      { name: 'Poultney High School', estsiz: '240', grades: '7-12', lat: 43.5165455, lng: -73.2294684, schcat: 'Junior-Senior High School', schdis: 'Poultney', townam: 'Poultney', value: false },
      { name: 'Pownal Elementary School', estsiz: '270', grades: 'K-6', lat: 42.8008263, lng: -73.2179873, schcat: 'Elementary School', schdis: 'Pownal', townam: 'Pownal', value: false },
      { name: 'Proctor Elementary School', estsiz: '180', grades: 'PK-6', lat: 43.6618191, lng: -73.038619, schcat: 'Elementary School', schdis: 'Proctor', townam: 'Proctor', value: false },
      { name: 'Proctor Junior-Senior High School', estsiz: '160', grades: '7-12', lat: 43.6550274, lng: -73.0291312, schcat: 'Junior-Senior High School', schdis: 'Proctor', townam: 'Proctor', value: false },
      { name: 'Putney Central School', estsiz: '190', grades: 'K-8', lat: 42.9858892, lng: -72.5284672, schcat: 'K-8', schdis: 'Putney', townam: 'Putney', value: false },
      { name: 'Randolph Elementary School', estsiz: '300', grades: 'K-6', lat: 43.9338797, lng: -72.6604606, schcat: 'Elementary School', schdis: 'Randolph', townam: 'Randolph', value: false },
      { name: 'Randolph UHSD No 2', estsiz: '460', grades: '7-12', lat: 43.931024, lng: -72.659843, schcat: 'Junior-Senior High School', schdis: 'Randolph UHSD', townam: 'Randolph', value: false },
      { name: 'Reading Elementary School', estsiz: '40', grades: 'K-6', lat: 43.453125, lng: -72.536659, schcat: 'Elementary School', schdis: 'Reading', townam: 'Reading', value: false },
      { name: 'Readsboro Elementary School', estsiz: '80', grades: 'PK-8', lat: 42.771786, lng: -72.940575, schcat: 'K-8', schdis: 'Readsboro', townam: 'Readsboro', value: false },
      { name: 'Richford Elementary School', estsiz: '250', grades: 'PK-6', lat: 44.9859909, lng: -72.6802834, schcat: 'Elementary School', schdis: 'Richford', townam: 'Richford', value: false },
      { name: 'Richford Junior-Senior High School', estsiz: '240', grades: '7-12', lat: 44.995025, lng: -72.670086, schcat: 'Junior-Senior High School', schdis: 'Richford', townam: 'Richford', value: false },
      { name: 'Richmond Elementary School', estsiz: '290', grades: 'PK-4', lat: 44.4126297, lng: -72.9939169, schcat: 'Elementary School', schdis: 'Richmond', townam: 'Richmond', value: false },
      { name: 'Rick Marcotte Central School', estsiz: '350', grades: 'K-5', lat: 44.467307, lng: -73.1769103, schcat: 'Elementary School', schdis: 'South Burlington', townam: 'So Burlington', value: false },
      { name: 'Ripton Elementary School', estsiz: '50', grades: 'PK-6', lat: 43.9852144, lng: -73.0382352, schcat: 'Elementary School', schdis: 'Ripton', townam: 'Ripton', value: false },
      { name: 'Rivendell Academy', estsiz: '230', grades: '7-12', lat: 43.899294, lng: -72.1376509, schcat: 'Junior-Senior High School', schdis: 'Rivendell Interstate USD', townam: 'Orford,  NH', value: false },
      { name: 'Riverside Middle School', estsiz: '310', grades: '6-8', lat: 43.3045496, lng: -72.4971886, schcat: 'Middle School', schdis: 'Springfield', townam: 'Springfield', value: false },
      { name: 'Robinson School', estsiz: '170', grades: 'K-6', lat: 44.223866, lng: -73.057693, schcat: 'Elementary School', schdis: 'Starksboro', townam: 'Starksboro', value: false },
      { name: 'Rochester School', estsiz: '160', grades: 'K-12', lat: 43.8717466, lng: -72.8091872, schcat: 'K-12', schdis: 'Rochester', townam: 'Rochester', value: false },
      { name: 'Roxbury Village School', estsiz: '40', grades: 'PK-6', lat: 44.092411, lng: -72.733185, schcat: 'Elementary School', schdis: 'Roxbury', townam: 'Roxbury', value: false },
      { name: 'Rumney School', estsiz: '180', grades: 'PK-6', lat: 44.351158, lng: -72.602592, schcat: 'Elementary School', schdis: 'Middlesex', townam: 'Middlesex', value: false },
      { name: 'Rutland High School', estsiz: '970', grades: '9-12', lat: 43.6174987, lng: -72.9546905, schcat: 'Senior High School', schdis: 'Rutland City', townam: 'Rutland', value: false },
      { name: 'Rutland Intermediate School', estsiz: '600', grades: '3-6', lat: 43.6131277, lng: -72.9799112, schcat: 'Elementary School', schdis: 'Rutland City', townam: 'Rutland', value: false },
      { name: 'Rutland Middle School', estsiz: '310', grades: '7-8', lat: 43.6129104, lng: -72.9809901, schcat: 'Middle School', schdis: 'Rutland City', townam: 'Rutland', value: false },
      { name: 'Rutland Town Elementary School', estsiz: '350', grades: 'PK-8', lat: 43.6386836, lng: -72.9634995, schcat: 'K-8', schdis: 'Rutland Town', townam: 'Rutland Town', value: false },
      { name: 'Salisbury Community School', estsiz: '90', grades: 'PK-6', lat: 43.919567, lng: -73.1188721, schcat: 'Elementary School', schdis: 'Salisbury', townam: 'Salisbury', value: false },
      { name: 'Samuel Morey Elementary School', estsiz: '160', grades: 'K-6', lat: 43.9079275, lng: -72.1461984, schcat: 'Elementary School', schdis: 'Rivendell Interstate USD', townam: 'Fairlee', value: false },
      { name: 'Saxtons River Elementary School', estsiz: '110', grades: 'K-5', lat: 43.140396, lng: -72.509491, schcat: 'Elementary School', schdis: 'Rockingham', townam: 'Saxtons River', value: false },
      { name: 'Shaftsbury Elementary School', estsiz: '220', grades: 'K-6', lat: 42.945183, lng: -73.207977, schcat: 'Elementary School', schdis: 'Shaftsbury', townam: 'Shaftsbury', value: false },
      { name: 'Sharon Elementary School', estsiz: '110', grades: 'PK-6', lat: 43.7849689, lng: -72.456039, schcat: 'Elementary School', schdis: 'Sharon', townam: 'Sharon', value: false },
      { name: 'Shelburne Community School', estsiz: '750', grades: 'PK-8', lat: 44.3807539, lng: -73.2353556, schcat: 'K-8', schdis: 'Shelburne', townam: 'Shelburne', value: false },
      { name: 'Sheldon Elementary School', estsiz: '240', grades: 'K-8', lat: 44.900993, lng: -72.969269, schcat: 'K-8', schdis: 'Sheldon', townam: 'Sheldon', value: false },
      { name: 'Shoreham Elementary School', estsiz: '100', grades: 'PK-6', lat: 43.891708, lng: -73.316238, schcat: 'Elementary School', schdis: 'Shoreham', townam: 'Shoreham', value: false },
      { name: 'Shrewsbury Mountain School', estsiz: '60', grades: 'PK-6', lat: 43.5255129, lng: -72.830734, schcat: 'Elementary School', schdis: 'Shrewsbury', townam: 'Cuttingsville', value: false },
      { name: 'Smilie Memorial School', estsiz: '90', grades: 'PK-4', lat: 44.373783, lng: -72.876854, schcat: 'Elementary School', schdis: 'Bolton', townam: 'Bolton', value: false },
      { name: 'South Burlington High School', estsiz: '890', grades: '9-12', lat: 44.454924, lng: -73.177891, schcat: 'Senior High School', schdis: 'South Burlington', townam: 'So Burlington', value: false },
      { name: 'South Royalton Elementary-High School', estsiz: '370', grades: 'PK-12', lat: 43.819316, lng: -72.517403, schcat: 'K-12', schdis: 'Royalton', townam: 'South Royalton', value: false },
      { name: 'Spaulding HSUD No 41', estsiz: '750', grades: '9-12', lat: 44.1894129, lng: -72.4935438, schcat: 'Senior High School', schdis: 'Spaulding UHSD', townam: 'Barre', value: false },
      { name: 'Springfield High School', estsiz: '460', grades: '9-12', lat: 43.2811126, lng: -72.4781557, schcat: 'Senior High School', schdis: 'Springfield', townam: 'Springfield', value: false },
      { name: 'St Albans City School', estsiz: '700', grades: 'K-8', lat: 44.8203212, lng: -73.0918317, schcat: 'K-8', schdis: 'St. Albans City', townam: 'St Albans', value: false },
      { name: 'St Albans Town Education Center', estsiz: '720', grades: 'K-8', lat: 44.8016334, lng: -73.0860045, schcat: 'K-8', schdis: 'St. Albans Town', townam: 'St Albans', value: false },
      { name: 'St Johnsbury Schools', estsiz: '660', grades: 'PK-8', lat: 44.4162817, lng: -72.0244301, schcat: 'K-8', schdis: 'St. Johnsbury', townam: 'St Johnsbury', value: false },
      { name: 'Stamford Elementary School', estsiz: '80', grades: 'K-8', lat: 42.7549141, lng: -73.0672467, schcat: 'K-8', schdis: 'Stamford', townam: 'Stamford', value: false },
      { name: 'Stockbridge Central School', estsiz: '60', grades: 'PK-6', lat: 43.7642684, lng: -72.7180882, schcat: 'Elementary School', schdis: 'Stockbridge', townam: 'Stockbridge', value: false },
      { name: 'Stowe Elementary School', estsiz: '280', grades: 'K-5', lat: 44.4630988, lng: -72.684254, schcat: 'Elementary School', schdis: 'Stowe', townam: 'Stowe', value: false },
      { name: 'Stowe Middle-High School', estsiz: '420', grades: '6-12', lat: 44.46533, lng: -72.726585, schcat: 'Junior-Senior High School', schdis: 'Stowe', townam: 'Stowe', value: false },
      { name: 'Sudbury Country School', estsiz: '30', grades: 'K-6', lat: 43.822178, lng: -73.185951, schcat: 'Elementary School', schdis: 'Sudbury', townam: 'Brandon', value: false },
      { name: 'Summit Street School', estsiz: '280', grades: 'PK-3', lat: 44.493408, lng: -73.11366, schcat: 'Elementary School', schdis: 'Essex Junction ID', townam: 'Essex Junction', value: false },
      { name: 'Sunderland Elementary School', estsiz: '70', grades: 'K-6', lat: 43.0846207, lng: -73.1277208, schcat: 'Elementary School', schdis: 'Sunderland', townam: 'Sunderland', value: false },
      { name: 'Sustainability Academy At Lawrence Barnes', estsiz: '210', grades: 'K-5', lat: 44.484143, lng: -73.2167958, schcat: 'Elementary School', schdis: 'Burlington', townam: 'Burlington', value: false },
      { name: 'Sutton School', estsiz: '100', grades: 'K-8', lat: 44.6335849, lng: -72.0278777, schcat: 'K-8', schdis: 'Sutton', townam: 'Sutton', value: false },
      { name: 'Swanton Schools', estsiz: '590', grades: 'PK-6', lat: 44.9153692, lng: -73.1130187, schcat: 'Elementary School', schdis: 'Swanton', townam: 'Swanton', value: false },
      { name: 'Thatcher Brook Primary USD No 45', estsiz: '430', grades: 'PK-4', lat: 44.339128, lng: -72.753139, schcat: 'Elementary School', schdis: 'Duxbury-Waterbury UESD', townam: 'Waterbury', value: false },
      { name: 'Thetford Elementary School', estsiz: '200', grades: 'K-6', lat: 43.8195834, lng: -72.2318682, schcat: 'Elementary School', schdis: 'Thetford', townam: 'Thetford', value: false },
      { name: 'Thomas Fleming School', estsiz: '220', grades: '4-5', lat: 44.49478, lng: -73.113504, schcat: 'Elementary School', schdis: 'Essex Junction ID', townam: 'Essex Junction', value: false },
      { name: 'Tinmouth Elementary School', estsiz: '60', grades: 'PK-6', lat: 43.4494929, lng: -73.0510709, schcat: 'Elementary School', schdis: 'Tinmouth', townam: 'Tinmouth', value: false },
      { name: 'Townshend Village School', estsiz: '90', grades: 'PK-6', lat: 43.0466625, lng: -72.6695342, schcat: 'Elementary School', schdis: 'Townshend', townam: 'Townshend', value: false },
      { name: 'Troy School', estsiz: '160', grades: 'K-8', lat: 44.995964, lng: -72.405022, schcat: 'K-8', schdis: 'Troy', townam: 'North Troy', value: false },
      { name: 'Tunbridge Central School', estsiz: '120', grades: 'PK-8', lat: 43.916965, lng: -72.474808, schcat: 'K-8', schdis: 'Tunbridge', townam: 'Tunbridge', value: false },
      { name: 'Twin Valley Joint Contract High School', estsiz: '160', grades: '9-12', lat: 42.7879692, lng: -72.8401605, schcat: 'Senior High School', schdis: 'Twin Valley Joint Contract High School', townam: 'Whitingham', value: false },
      { name: 'Twinfield USD No 33', estsiz: '430', grades: 'PK-12', lat: 44.2979795, lng: -72.3950348, schcat: 'K-12', schdis: 'Twinfield USD', townam: 'Plainfield', value: false },
      { name: 'U32 High School UHSD No 32', estsiz: '800', grades: '7-12', lat: 44.244409, lng: -72.526634, schcat: 'Junior-Senior High School', schdis: 'U-32 UHSD', townam: 'Montpelier', value: false },
      { name: 'Underhill Central School', estsiz: '180', grades: 'PK-4', lat: 44.5089403, lng: -72.8951245, schcat: 'Elementary School', schdis: 'Underhill Town', townam: 'Underhill Ctr', value: false },
      { name: 'Underhill ID School', estsiz: '110', grades: 'K-4', lat: 44.5179951, lng: -72.9456162, schcat: 'Elementary School', schdis: 'Underhill ID', townam: 'Jericho', value: false },
      { name: 'Union Elementary School', estsiz: '430', grades: 'K-5', lat: 44.2596714, lng: -72.5711386, schcat: 'Elementary School', schdis: 'Montpelier', townam: 'Montpelier', value: false },
      { name: 'Union Memorial School', estsiz: '220', grades: 'K-2', lat: 44.5490086, lng: -73.1601394, schcat: 'Elementary School', schdis: 'Colchester', townam: 'Colchester', value: false },
      { name: 'Union Street School', estsiz: '290', grades: '3-5', lat: 43.2955001, lng: -72.4880611, schcat: 'Elementary School', schdis: 'Springfield', townam: 'Springfield', value: false },
      { name: 'Vergennes UESD No 44', estsiz: '270', grades: 'K-6', lat: 44.167163, lng: -73.248079, schcat: 'Elementary School', schdis: 'Vergennes UESD', townam: 'Vergennes', value: false },
      { name: 'Vergennes UHSD No 5', estsiz: '580', grades: '7-12', lat: 44.1699484, lng: -73.2431089, schcat: 'Junior-Senior High School', schdis: 'Vergennes UHSD', townam: 'Vergennes', value: false },
      { name: 'Vernon Elementary School', estsiz: '160', grades: 'K-6', lat: 42.776263, lng: -72.518569, schcat: 'Elementary School', schdis: 'Vernon', townam: 'Vernon', value: false },
      { name: 'Waits River Valley USD No 36', estsiz: '210', grades: 'K-8', lat: 44.0797483, lng: -72.261316, schcat: 'K-8', schdis: 'Waits River Valley UESD', townam: 'East Corinth', value: false },
      { name: 'Waitsfield Elementary School', estsiz: '150', grades: 'PK-6', lat: 44.1944527, lng: -72.8193328, schcat: 'Elementary School', schdis: 'Waitsfield', townam: 'Waitsfield', value: false },
      { name: 'Walden School', estsiz: '100', grades: 'K-8', lat: 44.452801, lng: -72.219322, schcat: 'K-8', schdis: 'Walden', townam: 'West Danville', value: false },
      { name: 'Wallingford Village School', estsiz: '150', grades: 'PK-6', lat: 43.470547, lng: -72.9751579, schcat: 'Elementary School', schdis: 'Wallingford', townam: 'Wallingford', value: false },
      { name: 'Wardsboro Central School', estsiz: '70', grades: 'PK-6', lat: 43.0479574, lng: -72.7872992, schcat: 'Elementary School', schdis: 'Wardsboro', townam: 'Wardsboro', value: false },
      { name: 'Warren Elementary School', estsiz: '180', grades: 'PK-6', lat: 44.1162276, lng: -72.851123, schcat: 'Elementary School', schdis: 'Warren', townam: 'Warren', value: false },
      { name: 'Washington Village School', estsiz: '90', grades: 'PK-8', lat: 44.1078548, lng: -72.4315601, schcat: 'K-8', schdis: 'Washington', townam: 'Washington', value: false },
      { name: 'Waterford Elementary School', estsiz: '180', grades: 'PK-8', lat: 44.4025729, lng: -71.927544, schcat: 'K-8', schdis: 'Waterford', townam: 'St Johnsbury', value: false },
      { name: 'Waterville Elementary School', estsiz: '90', grades: 'PK-6', lat: 44.726855, lng: -72.74841, schcat: 'Elementary School', schdis: 'Waterville', townam: 'Waterville', value: false },
      { name: 'Weathersfield School', estsiz: '220', grades: 'K-8', lat: 43.4112673, lng: -72.4097514, schcat: 'K-8', schdis: 'Weathersfield', townam: 'Ascutney', value: false },
      { name: 'Wells Village School', estsiz: '80', grades: 'PK-6', lat: 43.417881, lng: -73.206711, schcat: 'Elementary School', schdis: 'Wells', townam: 'Wells', value: false },
      { name: 'West Rutland School', estsiz: '360', grades: 'PK-12', lat: 43.5954663, lng: -73.0515556, schcat: 'K-12', schdis: 'West Rutland', townam: 'West Rutland', value: false },
      { name: 'Westford Elementary School', estsiz: '220', grades: 'PK-8', lat: 44.602952, lng: -73.0189539, schcat: 'K-8', schdis: 'Westford', townam: 'Westford', value: false },
      { name: 'Westminster Schools', estsiz: '230', grades: 'PK-6', lat: 43.070309, lng: -72.463478, schcat: 'Elementary School', schdis: 'Westminster', townam: 'Westminster', value: false },
      { name: 'Westshire School', estsiz: '90', grades: 'K-6', lat: 43.9065664, lng: -72.2630234, schcat: 'Elementary School', schdis: 'Rivendell Interstate USD', townam: 'West Fairlee', value: false },
      { name: 'Weybridge Elementary School', estsiz: '60', grades: 'K-6', lat: 44.04174, lng: -73.212502, schcat: 'Elementary School', schdis: 'Weybridge', townam: 'Middlebury', value: false },
      { name: 'Whitcomb Junior-Senior High School', estsiz: '130', grades: '7-12', lat: 43.833232, lng: -72.6435001, schcat: 'Junior-Senior High School', schdis: 'Bethel', townam: 'Bethel', value: false },
      { name: 'White River School', estsiz: '240', grades: 'PK-5', lat: 43.6533157, lng: -72.3181378, schcat: 'Elementary School', schdis: 'Hartford', townam: 'White River Jct', value: false },
      { name: 'Whiting Village School', estsiz: '50', grades: 'PK-6', lat: 43.858121, lng: -73.2015179, schcat: 'Elementary School', schdis: 'Whiting', townam: 'Whiting', value: false },
      { name: 'Williamstown Elementary School', estsiz: '240', grades: 'PK-5', lat: 44.123554, lng: -72.545708, schcat: 'Elementary School', schdis: 'Williamstown', townam: 'Williamstown', value: false },
      { name: 'Williamstown Middle-High School', estsiz: '320', grades: '6-12', lat: 44.1262355, lng: -72.546661, schcat: 'Junior-Senior High School', schdis: 'Williamstown', townam: 'Williamstown', value: false },
      { name: 'Williston Schools', estsiz: '1', grades: 'PK-8', lat: 44.447771, lng: -73.096256, schcat: 'K-8', schdis: 'Williston', townam: 'Williston', value: false },
      { name: 'Windham Elementary School', estsiz: '20', grades: 'PK-6', lat: 43.1658297, lng: -72.7253414, schcat: 'Elementary School', schdis: 'Windham', townam: 'West Townshend', value: false },
      { name: 'Windsor High School', estsiz: '240', grades: '9-12', lat: 43.479936, lng: -72.394549, schcat: 'Senior High School', schdis: 'Windsor', townam: 'Windsor', value: false },
      { name: 'Windsor State Street School', estsiz: '310', grades: 'K-8', lat: 43.48093, lng: -72.394295, schcat: 'K-8', schdis: 'Windsor', townam: 'Windsor', value: false },
      { name: 'Winooski High School', estsiz: '270', grades: '9-12', lat: 44.501157, lng: -73.18101, schcat: 'Senior High School', schdis: 'Winooski ID', townam: 'Winooski', value: false },
      { name: 'Winooski Middle School', estsiz: '', grades: '', lat: 44.501157, lng: -73.18101, schcat: 'Middle School', schdis: 'Winooski ID', townam: 'Winooski', value: false },
      { name: 'Wolcott Elementary School', estsiz: '120', grades: 'K-6', lat: 44.538219, lng: -72.453148, schcat: 'Elementary School', schdis: 'Wolcott', townam: 'Wolcott', value: false },
      { name: 'Woodbury Elementary School', estsiz: '40', grades: 'K-6', lat: 44.440035, lng: -72.416224, schcat: 'Elementary School', schdis: 'Woodbury', townam: 'Woodbury', value: false },
      { name: 'Woodford Hollow School', estsiz: '30', grades: 'K-6', lat: 42.8939304, lng: -73.136866, schcat: 'Elementary School', schdis: 'Woodford', townam: 'Bennington', value: false },
      { name: 'Woodstock Elementary School', estsiz: '180', grades: 'K-6', lat: 43.622024, lng: -72.519711, schcat: 'Elementary School', schdis: 'Woodstock', townam: 'Woodstock', value: false },
      { name: 'Woodstock Senior UHSD No 4', estsiz: '180', grades: '9-12', lat: 43.613313, lng: -72.54568, schcat: 'Senior High School', schdis: 'Woodstock UHSD', townam: 'Woodstock', value: false },
      { name: 'Woodstock Union Middle School', estsiz: '180', grades: '7-8', lat: 43.613056, lng: -72.545857, schcat: 'Middle School', schdis: 'Woodstock UHSD', townam: 'Woodstock', value: false }
    ],
    verLat: [],
    deSiTe: [
      {
        name: '', //     0
        estsiz: '', //   1
        grades: '', //   2
        lat: 0, //       3
        lng: 0, //       4
        schcat: '', //   5
        schdis: '', //   6
        townam: '', //   7
        creatorId: '',
        value: false
      }
    ],
    estsiz: '',
    grades: '',
    schcat: '',
    schdis: '',
    townam: '',
    // removeUpdate: false,
    pixel: 8,
    schoolName: 'Mt Holly School',
    lat: 43.44585,
    lng: -72.823055,
    latlng: [43.44585, -72.823055],
    lnglat: [-72.823055, 43.44585],
    zoom: 12,
    types: ['car', 'directions_car', 'bike', 'directions_bike', 'walk', 'directions_walk'],
    typeIcon: 'directions_car',
    type: 'car',
    secondsSingle: [],
    seconds: [900, 0, 0],
    minutes: ['', '', 15, '', '', '', '', '', '', '', '', ''],
    fancyMinutes: [10, 20, 30],
    minuteA: '15 minutes',
    minuteB: '0 minutes',
    minuteC: '0 minutes',
    colorA: '#96c79d',
    colorB: '#e2ba8b',
    colorC: '#cc8f91',
    theColors: { five: '#7fa995', ten: '#96c79d', fifteen: '#b7ce98', twenty: '#e2ba8b', twentyfive: '#dfa38d', thirty: '#cc8f91', thirtyfive: '#7f7f7f', info: '#d3d3d3', deco: '#3388ff' },
    secondA: 900,
    secondB: 0,
    secondC: 0,
    singleTimes: [
      { minsb: 5, name: '5 min', secs: [300, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] },
      { minsb: 10, name: '10 min', secs: [0, 600, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] },
      { minsb: 15, name: '15 min', secs: [0, 0, 900, 0, 0, 0, 0, 0, 0, 0, 0, 0] },
      { minsb: 20, name: '20 min', secs: [0, 0, 0, 1200, 0, 0, 0, 0, 0, 0, 0, 0] },
      { minsb: 25, name: '25 min', secs: [0, 0, 0, 0, 1500, 0, 0, 0, 0, 0, 0, 0] },
      { minsb: 30, name: '30 min', secs: [0, 0, 0, 0, 0, 1800, 0, 0, 0, 0, 0, 0] },
      { minsb: 35, name: '35 min', secs: [0, 0, 0, 0, 0, 0, 2100, 0, 0, 0, 0, 0] },
      { minsb: 40, name: '40 min', secs: [0, 0, 0, 0, 0, 0, 0, 2400, 0, 0, 0, 0] },
      { minsb: 45, name: '45 min', secs: [0, 0, 0, 0, 0, 0, 0, 0, 2700, 0, 0, 0] },
      { minsb: 50, name: '50 min', secs: [0, 0, 0, 0, 0, 0, 0, 0, 0, 3000, 0, 0] },
      { minsb: 55, name: '55 min', secs: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3300, 0] },
      { minsb: 60, name: '60 min', secs: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3600] }
    ],
    travelTimes: [
      { minsb: [5, 10, 15], name: '5 min, 10 min, 15 min', secs: [300, 600, 900] },
      { minsb: [10, 15, 20], name: '10 min, 15 min, 20 min', secs: [600, 900, 1200] },
      { minsb: [15, 20, 25], name: '15 min, 20 min, 25 min', secs: [900, 1200, 1500] },
      { minsb: [20, 25, 30], name: '20 min, 25 min, 30 min', secs: [1200, 1500, 1800] },
      { minsb: [25, 30, 35], name: '25 min, 30 min, 35 min', secs: [1500, 1800, 2100] },
      { minsb: [30, 35, 40], name: '30 min, 35 min, 40 min', secs: [1800, 2100, 2400] },
      { minsb: [5, 15, 25], name: '5 min, 15 min, 25 min', secs: [300, 900, 1500] },
      { minsb: [10, 20, 30], name: '10 min, 20 min, 30 min', secs: [600, 1200, 1800] },
      { minsb: [15, 25, 35], name: '15 min, 25 min, 35 min', secs: [900, 1500, 2100] },
      { minsb: [20, 30, 40], name: '20 min, 30 min, 40 min', secs: [1200, 1800, 2400] },
      { minsb: [25, 35, 45], name: '25 min, 35 min, 45 min', secs: [1500, 2100, 2700] },
      { minsb: [30, 40, 50], name: '30 min, 40 min, 50 min', secs: [1800, 2400, 3000] },
      { minsb: [5, 20, 35], name: '5 min, 20 min, 35 min', secs: [300, 1200, 2100] },
      { minsb: [10, 25, 40], name: '10 min, 25 min, 40 min', secs: [600, 1500, 2400] },
      { minsb: [15, 30, 45], name: '15 min, 30 min, 45 min', secs: [900, 1800, 2700] },
      { minsb: [20, 35, 50], name: '20 min, 35 min, 50 min', secs: [1200, 2100, 3000] },
      { minsb: [25, 40, 55], name: '25 min, 40 min, 55 min', secs: [1500, 2400, 3300] },
      { minsb: [30, 45, 60], name: '30 min, 45 min, 60 min', secs: [1800, 2700, 3600] },
      { minsb: [5, 25, 45], name: '5 min, 25 min, 45 min', secs: [300, 1500, 2700] },
      { minsb: [10, 30, 50], name: '10 min, 30 min, 50 min', secs: [600, 1800, 3000] },
      { minsb: [15, 35, 55], name: '15 min, 35 min, 55 min', secs: [900, 2100, 3300] },
      { minsb: [20, 40, 60], name: '20 min, 40 min, 60 min', secs: [1200, 2400, 3600] }
    ],
    secMin: [300, 5, 600, 10, 900, 15, 1200, 20, 1500, 25, 1800, 30, 2100, 35, 2400, 40, 2700, 45, 3000, 50, 3300, 55, 3600, 60],
    baseOption: 'watercolor',
    stamenBaseOptions: ['toner', 'toner-hybrid', 'toner-labels', 'toner-lines', 'toner-background', 'toner-lite', 'terrain', 'terrain-background', 'terrain-lines', 'terrain-labels',
      'terrain-classic', 'watercolor', 'trees-cabs-crime'],
    idFrom: 'mb3'
    // baseOptionStyle: 'mapbox://styles/altophoto/cja75wqs453kd2so2720o3bpe'
  },
  getters: {
    //
    // ------------------------------- CUTOUT LOGIC
    loadedCutout (state) {
      return (cutoutId) => {
        return state.loadedCutouts.find((cutout) => {
          return cutout.id === cutoutId
        })
      }
    },
    loadedCutouts (state) {
      return state.loadedCutouts.sort((cutoutA, cutoutB) => {
        return cutoutA.id > cutoutB.id
      })
    },
    //
    // ------------------------------- APP LOGIC
    user (state) {
      return state.user
    },
    loading (state) {
      return state.loading
    },
    error (state) {
      return state.error
    },
    //
    // ------------------------------- INFO AND PICKERS
    schoolName (state) {
      return state.schoolName
    },
    pixel (state) {
      return state.pixel
    },
    lat (state) {
      return state.deSiTe.lat
    },
    lng (state) {
      return state.deSiTe.lng
    },
    latlng (state) {
      return state.latlng
    },
    lnglat (state) {
      return state.lnglat
    },
    zoom (state) {
      return state.zoom
    },
    type (state) {
      return state.type
    },
    inverse (state) {
      return state.inverse
    },
    cluster (state) {
      return state.cluster
    },
    //
    // -------------------------------  POI DATA TABLE
    verPois (state) {
      return state.verPois
    },
    // -------------------------------  SCHOOL DATA TABLE
    verLat (state) {
      return state.verLat
    },
    verSch (state) {
      return state.verSch
    },
    deSiTe (state) {
      return state.deSiTe
    },
    estsiz (state) {
      return state.estsiz
    },
    grades (state) {
      return state.grades
    },
    schcat (state) {
      return state.schcat
    },
    schdis (state) {
      return state.schdis
    },
    townam (state) {
      return state.townam
    },
    //
    // -------------------------------  TIME LOGIC
    travelTimes (state) {
      return state.travelTimes
    },
    singleTimes (state) {
      return state.singleTimes
    },
    seconds (state) {
      return state.seconds
    },
    minutes (state) {
      return state.minutes
    },
    secMin (state) {
      return state.secMin
    },
    //
    // -------------------------------  FANCY DOM ELEMENTS
    allTheColors (state) {
      return state.theColors
    },
    fancyMinutes (state) {
      return state.fancyMinutes
    },
    fancyMinuteZero (state) {
      return state.fancyMinutes[0]
    },
    fancyMinuteOne (state) {
      return state.fancyMinutes[1]
    },
    fancyMinuteTwo (state) {
      return state.fancyMinutes[2]
    },
    colorA (state) {
      return state.colorA
    },
    colorB (state) {
      return state.colorB
    },
    colorC (state) {
      return state.colorC
    },
    minuteA (state) {
      return state.minuteA
    },
    minuteB (state) {
      return state.minuteB
    },
    minuteC (state) {
      return state.minuteC
    },
    typeIcon (state) {
      return state.typeIcon
    },
    baseOption (state) {
      return state.baseOption
    },
    baseOptionStyle (state) {
      return state.baseOptionStyle
    },
    stamenBaseOptions (state) {
      return state.stamenBaseOptions
    },
    knowIdFrom (state) {
      return state.idFrom
    }
    /*  ------------------------------- CHUFF
    punchlist (state) {
      return state.punchlist
    },
    mapping (state) {
      return state.mapping
    }
    */
  },
  mutations: {
    setUser (state, payload) {
      state.user = payload
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setError (state, payload) {
      state.error = payload
    },
    clearError (state) {
      state.error = null
    },
    /*
    setMapping (state, payload) {
      state.mapping = payload
    },
    */
    setSchoolName (state, payload) {
      state.schoolName = payload
    },
    registerUserForCutout (state, payload) {
      const id = payload.id
      if (state.user.registeredCutouts.findIndex(cutout => cutout.id === id) >= 0) {
        return
      }
      state.user.registeredCutouts.push(id)
      state.user.fbKeys[id] = payload.fbKey
    },
    unregisterUserFromCutout (state, payload) {
      const registeredCutouts = state.user.registeredCutouts
      registeredCutouts.splice(registeredCutouts.findIndex(cutout => cutout.id === payload), 1)
      Reflect.deleteProperty(state.user.fbKeys, payload)
    },
    setLoadedCutouts (state, payload) {
      state.loadedCutouts = payload
    },
    createCutout (state, payload) {
      state.loadedCutouts.push(payload)
    },
    updateCutout (state, payload) {
      const cutout = state.loadedCutouts.find(cutout => {
        return cutout.id === payload.id
      })
      if (payload.title) {
        cutout.title = payload.title
      }
      if (payload.description) {
        cutout.description = payload.description
      }
      if (payload.date) {
        cutout.date = payload.date
      }
    },
    createIsochron (state, payload) {
      state.deSiTe = payload
    },
    setLat (state, payload) {
      state.lat = payload
      state.latlng[0] = payload
      state.lnglat[1] = payload
    },
    setLng (state, payload) {
      state.lng = payload
      state.latlng[1] = payload
      state.lnglat[0] = payload
    },
    setPixel (state, payload) {
      state.pixel = payload
    },
    setMins (state, payload) {
      state.minutes = payload
    },
    setFancyMins (state, payload) {
      state.fancyMinutes = payload
    },
    setSecs (state, payload) {
      state.seconds = payload
    },
    setTwoTone (state, payload) {
      state.inverse = payload
    },
    setColorA (state, payload) {
      state.colorA = payload
    },
    setColorB (state, payload) {
      state.colorB = payload
    },
    setColorC (state, payload) {
      state.colorC = payload
    },
    setMinuteA (state, payload) {
      state.minuteA = payload
    },
    setMinuteB (state, payload) {
      state.minuteB = payload
    },
    setMinuteC (state, payload) {
      state.minuteC = payload
    },
    setTypeIcon (state, payload) {
      state.typeIcon = payload
    },
    setType (state, payload) {
      state.type = payload
    },
    setBase (state, payload) {
      state.baseOption = payload
    },
    setBaseStyle (state, payload) {
      state.baseOptionStyle = payload
    },
    setIdFrom (state, payload) {
      state.idFrom = payload
    }
  },
  actions: {
    signUserUp ({commit}, payload) {
      commit('setLoading', true)
      commit('clearError')
      firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
        .then(
          user => {
            commit('setLoading', false)
            const newUser = {
              id: user.uid,
              registeredCutouts: [],
              fbKeys: {}
            }
            commit('setUser', newUser)
          }
        )
        .catch(
          error => {
            commit('setLoading', false)
            commit('setError', error)
            console.log(error)
          }
        )
    },
    signUserIn ({commit}, payload) {
      commit('setLoading', true)
      commit('clearError')
      firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
        .then(
          user => {
            commit('setLoading', false)
            const newUser = {
              id: user.uid,
              registeredCutouts: [],
              fbKeys: {}
            }
            commit('setUser', newUser)
          }
        )
        .catch(
          error => {
            commit('setLoading', false)
            commit('setError', error)
            console.log(error)
          }
        )
    },
    autoSignIn ({commit}, payload) {
      commit('setUser', {
        id: payload.uid,
        registeredCutouts: [],
        fbKeys: {}
      })
    },
    logout ({commit}) {
      firebase.auth().signOut()
      commit('setUser', null)
    },
    pickPoi ({commit}, payload) {
      const nps = {
        name: payload.name,
        lat: payload.lat,
        lng: payload.lng,
        townam: payload.town
        // creatorId: getters.user.id
      }
      let nsm = nps.name
      let nlat = nps.lat
      let nlng = nps.lng
      commit('createIsochron', {...nps})
      commit('setSchoolName', nsm)
      commit('setLat', nlat)
      commit('setLng', nlng)
    },
    pickSchool ({commit}, payload) {
      const nps = {
        name: payload.name,
        estsiz: payload.estsiz,
        grades: payload.grades,
        lat: payload.lat,
        lng: payload.lng,
        schcat: payload.schcat,
        schdis: payload.schdis,
        townam: payload.townam
        // creatorId: getters.user.id
      }
      let nsm = nps.name
      let nlat = nps.lat
      let nlng = nps.lng
      commit('createIsochron', {...nps})
      commit('setSchoolName', nsm)
      commit('setLat', nlat)
      commit('setLng', nlng)
    },
    pickPixels ({commit}, payload) {
      commit('setPixel', payload)
    },
    pickMins ({commit}, payload) {
      commit('setMins', payload)
    },
    soloM ({commit, getters}, payload) {
      commit('setFancyMins', payload)
    },
    pickType ({commit}, payload) {
      let mode = payload
      let modeIcon = 'directions_car'
      //, 'bike', 'directions_bike', 'walk', 'directions_walk''
      if (mode === 'walk') {
        let modeIcon = 'directions_walk'
        commit('setTypeIcon', modeIcon)
        commit('setType', mode)
      }
      if (mode === 'bike') {
        let modeIcon = 'directions_bike'
        commit('setTypeIcon', modeIcon)
        commit('setType', mode)
      }
      if (mode === 'car') {
        let modeIcon = 'directions_car'
        commit('setTypeIcon', modeIcon)
        commit('setType', mode)
      }
    },
    pickSecs ({commit}, payload) {
      let secA = payload[0]
      let secB = payload[1]
      let secC = payload[2]
      let colorfiv = '#7fa995'
      let colorten = '#96c79d'
      let colorfif = '#b7ce98'
      let colortwy = '#e2ba8b'
      let colortwf = '#dfa38d'
      let colorthy = '#cc8f91'
      let colorthf = '#7f7f7f'
      let colornul = '#F0E9D8'
      let colorA = ''
      let colorB = ''
      let colorC = ''
      let minuteA = ''
      let minuteB = ''
      let minuteC = ''
      if (secA === 300) {
        let colorA = colorfiv
        let minuteA = '5 minutes'
        commit('setColorA', colorA)
        commit('setMinuteA', minuteA)
      }
      if (secA === 600) {
        let colorA = colorten
        let minuteA = '10 minutes'
        commit('setColorA', colorA)
        commit('setMinuteA', minuteA)
      }
      if (secA === 900) {
        let colorA = colorfif
        let minuteA = '15 minutes'
        commit('setColorA', colorA)
        commit('setMinuteA', minuteA)
      }
      if (secA === 1200) {
        let colorA = colortwy
        let minuteA = '20 minutes'
        commit('setColorA', colorA)
        commit('setMinuteA', minuteA)
      }
      if (secA === 1500) {
        let colorA = colortwf
        let minuteA = '25 minutes'
        commit('setColorA', colorA)
        commit('setMinuteA', minuteA)
      }
      if (secA === 1800) {
        let colorA = colorthy
        let minuteA = '30 minutes'
        commit('setColorA', colorA)
        commit('setMinuteA', minuteA)
      }
      if (secA === 2100) {
        let colorA = colorthf
        let minuteA = '35 minutes'
        commit('setColorA', colorA)
        commit('setMinuteA', minuteA)
      }
      if (secA === 2400) {
        let colorA = colorthf
        let minuteA = '40 minutes'
        commit('setColorA', colorA)
        commit('setMinuteA', minuteA)
      }
      if (secA === 2700) {
        let colorA = colorthf
        let minuteA = '45 minutes'
        commit('setColorA', colorA)
        commit('setMinuteA', minuteA)
      }
      if (secA === 3000) {
        let colorA = colorthf
        let minuteA = '50 minutes'
        commit('setColorA', colorA)
        commit('setMinuteA', minuteA)
      }
      if (secA === 3300) {
        let colorA = colorthf
        let minuteA = '55 minutes'
        commit('setColorA', colorA)
        commit('setMinuteA', minuteA)
      }
      if (secA === 3600) {
        let colorA = colorthf
        let minuteA = '60 minutes'
        commit('setColorA', colorA)
        commit('setMinuteA', minuteA)
      }
      if (secB === 600) {
        let colorB = colorten
        let minuteB = '10 minutes'
        commit('setMinuteB', minuteB)
        commit('setColorB', colorB)
      }
      if (secB === 900) {
        let colorB = colorfif
        let minuteB = '15 minutes'
        commit('setMinuteB', minuteB)
        commit('setColorB', colorB)
      }
      if (secB === 1200) {
        let colorB = colortwy
        let minuteB = '20 minutes'
        commit('setMinuteB', minuteB)
        commit('setColorB', colorB)
      }
      if (secB === 1500) {
        let colorB = colortwf
        let minuteB = '25 minutes'
        commit('setMinuteB', minuteB)
        commit('setColorB', colorB)
      }
      if (secB === 1800) {
        let colorB = colorthy
        let minuteB = '30 minutes'
        commit('setMinuteB', minuteB)
        commit('setColorB', colorB)
      }
      if (secB === 2100) {
        let colorB = colorthf
        let minuteB = '35 minutes'
        commit('setMinuteB', minuteB)
        commit('setColorB', colorB)
      }
      if (secB === 2400) {
        let colorB = colorthf
        let minuteB = '40 minutes'
        commit('setMinuteB', minuteB)
        commit('setColorB', colorB)
      }
      if (secB === 2700) {
        let colorB = colorthf
        let minuteB = '45 minutes'
        commit('setMinuteB', minuteB)
        commit('setColorB', colorB)
      }
      if (secB === 3000) {
        let colorB = colorthf
        let minuteB = '50 minutes'
        commit('setMinuteB', minuteB)
        commit('setColorB', colorB)
      }
      if (secB === 3300) {
        let colorB = colorthf
        let minuteB = '55 minutes'
        commit('setMinuteB', minuteB)
        commit('setColorB', colorB)
      }
      if (secB === 3600) {
        let colorB = colorthf
        let minuteB = '60 minutes'
        commit('setMinuteB', minuteB)
        commit('setColorB', colorB)
      }
      if (secC === 900) {
        let colorC = colorfif
        let minuteC = '15 minutes'
        commit('setColorC', colorC)
        commit('setMinuteC', minuteC)
      }
      if (secC === 1200) {
        let colorC = colortwy
        let minuteC = '20 minutes'
        commit('setColorC', colorC)
        commit('setMinuteC', minuteC)
      }
      if (secC === 1500) {
        let colorC = colortwf
        let minuteC = '25 minutes'
        commit('setColorC', colorC)
        commit('setMinuteC', minuteC)
      }
      if (secC === 1800) {
        let colorC = colorthy
        let minuteC = '30 minutes'
        commit('setColorC', colorC)
        commit('setMinuteC', minuteC)
      }
      if (secC === 2100) {
        let colorC = colorthf
        let minuteC = '35 minutes'
        commit('setColorC', colorC)
        commit('setMinuteC', minuteC)
      }
      if (secC === 2400) {
        let colorC = colorthf
        let minuteC = '40 minutes'
        commit('setColorC', colorC)
        commit('setMinuteC', minuteC)
      }
      if (secC === 2700) {
        let colorC = colorthf
        let minuteC = '45 minutes'
        commit('setColorC', colorC)
        commit('setMinuteC', minuteC)
      }
      if (secC === 3000) {
        let colorC = colorthf
        let minuteC = '50 minutes'
        commit('setColorC', colorC)
        commit('setMinuteC', minuteC)
      }
      if (secC === 3300) {
        let colorC = colorthf
        let minuteC = '55 minutes'
        commit('setColorC', colorC)
        commit('setMinuteC', minuteC)
      }
      if (secC === 3600) {
        let colorC = colorthf
        let minuteC = '60 minutes'
        commit('setColorC', colorC)
        commit('setMinuteC', minuteC)
      }
      if (secB === 0 || secB === undefined || secB === null) {
        let colorB = colornul
        let colorC = colornul
        let minuteB = ''
        let minuteC = ''
        commit('setMinuteB', minuteB)
        commit('setColorB', colorB)
        commit('setColorC', colorC)
        commit('setMinuteC', minuteC)
      }
      if (secC === 0 || secC === undefined || secC === null) {
        let colorC = colornul
        let minuteC = ''
        commit('setColorC', colorC)
        commit('setMinuteC', minuteC)
      }
      commit('setSecs', payload)
    },
    clearError ({commit}) {
      commit('clearError')
    },
    twoTone ({commit, getters}, payload) {
      commit('setTwoTone', payload)
    },
    pickBase ({commit}, payload) {
      commit('setBase', payload)
    },
    idFrom ({commit}, payload) {
      commit('setIdFrom', payload)
    }
    /*
      let pB = payload
      let bOs = ''
      if (pB === 'Vintage') {
        let bOs = 'mapbox://styles/altophoto/cjabw6nax3sgf2sntkany1okv'
        L.mapbox.styleLayer.clearLayers().addLayer(bOs)
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Decimal') {
        // L.mapbox.styleLayer
        let bOs = 'mapbox://styles/altophoto/cjabw6wco3rhb2rsum3ay5y9g'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Terminal') {
        // L.mapbox.styleLayer
        let bOs = 'mapbox://styles/altophoto/cjabw6tqe2xzp2rmoqpt6rkl2'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'VT Town Boundaries') {
        // L.mapbox.styleLayer
        let bOs = 'mapbox://styles/altophoto/cj84l42cs0sto2rkscn16kr7w'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Red Pins') {
        // L.mapbox.styleLayer
        let bOs = 'mapbox://styles/altophoto/cj8a5r73162xj2sr3g8ajtn0v'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Basic Vector') {
        // L.mapbox.styleLayer
        let bOs = 'mapbox://styles/altophoto/cja75t6cv53ha2smw8klm7h9k'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Scenic') {
        // L.mapbox.styleLayer
        let bOs = 'mapbox://styles/altophoto/cjabw6lvk2xv02rs66t75a3i1'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Town and Country') {
        // L.mapbox.styleLayer
        let bOs = 'mapbox://styles/altophoto/cj89zxu1j5w742rk7t1x8vvvv'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'North Star') {
        // L.mapbox.styleLayer
        let bOs = 'mapbox://styles/altophoto/cjabw72f33rjf2spe4pnh4jbh'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Ice Cream') {
        // L.mapbox.styleLayer
        let bOs = 'mapbox://styles/altophoto/cjabw6pmb3rj62spea81rd8he'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Desert planet') {
        // L.mapbox.styleLayer
        let bOs = 'mapbox://styles/altophoto/cjabw7f3m3sh82snteo04mp4o'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'whaam!') {
        // L.mapbox.styleLayer
        let bOs = 'mapbox://styles/altophoto/cjabw6wxi3qu52snwk1xqiv44'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Satellite Vector') {
        // L.mapbox.styleLayer
        let bOs = 'mapbox://styles/altophoto/cja75y07p540k2spn6tfoh42k'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Satellite Streets Vector') {
        // L.mapbox.styleLayer
        let bOs = 'mapbox://styles/altophoto/cja7691sd53vs2so222ytty85'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Outdoors') {
        // L.mapbox.styleLayer
        let bOs = 'mapbox://styles/altophoto/cja75wqs453kd2so2720o3bpe'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
    }
    /*
      if (pB === 'OpenStreetMap Default') {
        // L.tileLayer.provider
        let bOs = 'OpenStreetMap.Mapnik'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'OpenStreetMap German Style') {
        // L.tileLayer.provider
        let bOs = 'OpenStreetMap.DE'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'OpenStreetMap Black and White') {
        // L.tileLayer.provider
        let bOs = 'OpenStreetMap.BlackAndWhite'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'OpenStreetMap H.O.T.') {
        // L.tileLayer.provider
        let bOs = 'OpenStreetMap.HOT'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Red Pins-Raster') {
        // L.tileLayer.provider
        let bOs = 'RedPins'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'VT Town Boundaries-Raster') {
        // L.tileLayer.provider
        let bOs = 'TownBoundaries'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Town and Country-Raster') {
        // L.tileLayer.provider
        let bOs = 'TownAndCountry'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Outdoors-Raster') {
        // L.tileLayer.provider
        let bOs = 'Outdoors'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Raster Satellite') {
        // L.tileLayer.provider
        let bOs = 'Satellite'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Satellite Streets') {
        // L.tileLayer.provider
        let bOs = 'SatelliteStreets'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Hydda') {
        // L.tileLayer.provider
        let bOs = 'Hydda.Full'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Basic') {
        // L.tileLayer.provider
        let bOs = 'BasicMapbox'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }

      if (pB === 'Toner') {
        // L.tileLayer.provider
        let bOs = .tileLayer.provid
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === ('Toner')) {
        // L.tileLayer.provider
        let bOs = ''
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === ('Watercolor')) {
        // L.tileLayer.provider
        let bOs = ''
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }

      if (pB === 'Terrain') {
        // L.tileLayer.provider
        let bOs = 'Stamen.Terrain'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }

      if (pB === 'Esri WorldStreetMap') {
        // L.tileLayer.provider
        let bOs = 'Esri.WorldStreetMap'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Esri DeLorme') {
        // L.tileLayer.provider
        let bOs = 'Esri.DeLorme'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Esri WorldTopoMap') {
        // L.tileLayer.provider
        let bOs = 'Esri.WorldTopoMap'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Esri WorldImagery') {
        // L.tileLayer.provider
        let bOs = 'Esri.WorldImagery'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Esri WorldTerrain') {
        // L.tileLayer.provider
        let bOs = 'Esri.WorldTerrain'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Esri WorldShadedRelief') {
        // L.tileLayer.provider
        let bOs = 'Esri.WorldShadedRelief'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Esri WorldPhysical') {
        // L.tileLayer.provider
        let bOs = 'Esri.WorldPhysical'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Esri OceanBasemap') {
        // L.tileLayer.provider
        let bOs = 'Esri.OceanBasemap'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Esri NatGeoWorldMap') {
        // L.tileLayer.provider
        let bOs = 'Esri.NatGeoWorldMap'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Esri WorldGrayCanvas') {
        // L.tileLayer.provider
        let bOs = 'Esri.WorldGrayCanvas'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }

      'Decimal': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw6wco3rhb2rsum3ay5y9g'),
      'Terminal': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw6tqe2xzp2rmoqpt6rkl2'),
      // Vermont
      'VT Town Boundaries': L.mapbox.styleLayer('mapbox://styles/altophoto/cj84l42cs0sto2rkscn16kr7w'),
      'Red Pins': L.mapbox.styleLayer('mapbox://styles/altophoto/cj8a5r73162xj2sr3g8ajtn0v'),
      // Open Street Map
      'OpenStreetMap Default': L.tileLayer.provider('OpenStreetMap.Mapnik'),
      'OpenStreetMap German Style': L.tileLayer.provider('OpenStreetMap.DE'),
      'OpenStreetMap Black and White': L.tileLayer.provider('OpenStreetMap.BlackAndWhite'),
      'OpenStreetMap H.O.T.': L.tileLayer.provider('OpenStreetMap.HOT'),
      // Raster
      'Red Pins-Raster': L.tileLayer.provider('RedPins'),
      'VT Town Boundaries-Raster': L.tileLayer.provider('TownBoundaries'),
      'Town and Country-Raster': L.tileLayer.provider('TownAndCountry'),
      'Outdoors-Raster': L.tileLayer.provider('Outdoors'),
      'Raster Satellite': L.tileLayer.provider('Satellite'),
      'Satellite Streets': L.tileLayer.provider('SatelliteStreets'),
      // Slick
      'Hydda': L.tileLayer.provider('Hydda.Full'),
      'Basic Mapbox': L.tileLayer.provider('BasicMapbox'),
      'Basic Vector': L.mapbox.styleLayer('mapbox://styles/altophoto/cja75t6cv53ha2smw8klm7h9k'),
      'Scenic': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw6lvk2xv02rs66t75a3i1'),
      'Town and Country': L.mapbox.styleLayer('mapbox://styles/altophoto/cj89zxu1j5w742rk7t1x8vvvv'),
      'Standard': defaultLayer,
      'North Star': L.mapbox.styleLayer ('mapbox://styles/altophoto/cjabw72f33rjf2spe4pnh4jbh'),
      // Funky
      'Toner': L.tileLayer.provider('Stamen.Toner'),
      'Watercolor': L.tileLayer.provider('Stamen.Watercolor'),
      'Vintage': L.mapbox.styleLayer(),
      'Ice Cream': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw6pmb3rj62spea81rd8he'),
      'Desert planet': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw7f3m3sh82snteo04mp4o'),
      'whaam!': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw6wxi3qu52snwk1xqiv44'),
      // Outdoors
      'Terrain': L.tileLayer.provider('Stamen.Terrain'),
      '(vector) Satellite': L.mapbox.styleLayer('mapbox://styles/altophoto/cja75y07p540k2spn6tfoh42k'),
      '(vector) Satellite Streets': L.mapbox.styleLayer('mapbox://styles/altophoto/cja7691sd53vs2so222ytty85'),
      'Outdoors': L.mapbox.styleLayer('mapbox://styles/altophoto/cja75wqs453kd2so2720o3bpe'),
      // Esri
      'Esri WorldStreetMap': L.tileLayer.provider('Esri.WorldStreetMap'),
      'Esri DeLorme': L.tileLayer.provider('Esri.DeLorme'),
      'Esri WorldTopoMap': L.tileLayer.provider('Esri.WorldTopoMap'),
      'Esri WorldImagery': L.tileLayer.provider('Esri.WorldImagery'),
      'Esri WorldTerrain': L.tileLayer.provider('Esri.WorldTerrain'),
      'Esri WorldShadedRelief': L.tileLayer.provider('Esri.WorldShadedRelief'),
      'Esri WorldPhysical': L.tileLayer.provider('Esri.WorldPhysical'),
      'Esri OceanBasemap': L.tileLayer.provider('Esri.OceanBasemap'),
      'Esri NatGeoWorldMap': L.tileLayer.provider('Esri.NatGeoWorldMap'),
      'Esri WorldGrayCanvas': L.tileLayer.provider('Esri.WorldGrayCanvas')
    */
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js